<template>
  <div class="login" :style="{'backgroundImage':'url('+loginBgImageUrl+')'}">
      <div class="cont">
          <div class="login-main">
              <!-- ============= 左侧图片 ============= -->
              <div class="left">
                  <img src="../../assets/images/login/sign-in.png">
              </div>

              <!-- ============= 登录Form ============= -->
              <div class="login-box">
                  <el-form :model="account" style="text-align: center;">
                      <el-input class="box-user" v-model="account.userName" @keyup.enter.native="enterSearch" placeholder="账号">
                          <templat slot="prepend">
                              <i class="el-icon-user"></i>
                          </templat>
                      </el-input>

                      <el-input class="box-password" type="password" v-model="account.passWord" @keyup.enter.native="enterSearch" placeholder="密码">
                          <template slot="prepend">
                            <i class="el-icon-lock"></i>
                          </template>
                      </el-input>
                  </el-form>

                  <!-- ============= 登录按钮 ============= -->
                  <div style="text-align: center;">
                      <el-button class="login-button"  type="primary" @click="sendLogin" :loading="isLoad">登陆</el-button>
                  </div>

                  <div class="next-login" >
                      <el-checkbox  v-model="nextLogin" id="nextLogin"  label="1" style="margin-left: 95px">下次自动登录</el-checkbox>
                      <a class="retrieve-password" href="">找回密码</a>
                  </div>

                  <div class="login-register">
                      <span>注册新用户</span>
                  </div>
              </div>
          </div>
      </div>
  </div>
</template>

<script>
    import Header from '@/pages/header'
    import Footer from '@/pages/footer'

    export default {
        data() {
            return {
                isLoad:false,
                loginBgImageUrl : require("../../assets/images/login/login-background.png"),
                nextLogin:true, // 下次自动登录
                account: {
                  userName: '',
                  passWord: '',
                },
            }
        },
        mounted() {

        },
        watch:{

        },
        methods: {
            // 登录
            sendLogin() {

            },
            // 登录失败
            loginFail() {
              this.$message.error('用户名或密码错误！');
            },
            // 回车自动登录
            enterSearch:function(e){
              e.target.blur();
              this.sendLogin();
            },
            components: {
              Header,
              Footer
            }
        }
    }
</script>

<style>
    .login { display: table; width: 100%;height: 840px;background-size: cover; }
    .login > .cont { display: table-cell; text-align: center; vertical-align: middle; }
    .login > .cont .login-main { display: inline-block; margin: 0 auto;  text-align: left; }
    .login > .cont .login-main > .login-box { width: 560px;height: 667px; background-color: #fff; margin-left: 457px; }
    .login > .cont .login-main > .left { margin-left: 30px;width: 440px; float: left; position: relative; }
    .login > .cont .login-main > .left img { width: 427px; height: 667px;  }
    .login .next-login { margin: 30px 0px 0 0 }
    .login .retrieve-password { font-size: 14px;font-family: "Microsoft YaHei UI";text-decoration: none;color: #4A90E2;margin-left: 160px }
    .login .login-register {color: #4A90E2;font-size: 24px;margin-left: 230px;margin-top: 120px;cursor: pointer}
    .login .box-user { width: 360px;outline: none;margin-top: 200px }
    .login .box-password { width: 360px; margin: 20px 3px 0 0;outline: none }
    .login .login-button { width: 360px;margin-top: 30px }
</style>



// WEBPACK FOOTER //
// src/pages/login/login.vue